<div class="subsidiaryDiv">
  <p>{{legalNoticesTxt.headingLbl?legalNoticesTxt.headingLbl:legalNotices.headingLbl}}</p>
</div>
<div class="mainDiv">
  <h4>{{legalNoticesTxt.subHeadingLbl?legalNoticesTxt.subHeadingLbl:legalNotices.subHeadingLbl}}</h4>

  <p>
    {{legalNoticesTxt.content1Lbl?legalNoticesTxt.content1Lbl:legalNotices.content1Lbl}}:
  </p>

  <ol type="1">
    <li>
      {{legalNoticesTxt.content2Lbl?legalNoticesTxt.content2Lbl:legalNotices.content2Lbl}} <a href="mailto:editor@Arconic.com">{{legalNoticesTxt.emailTextLbl?legalNoticesTxt.emailTextLbl:legalNotices.emailTextLbl}}</a>
    </li>
    <li>
      {{legalNoticesTxt.content3Lbl?legalNoticesTxt.content3Lbl:legalNotices.content3Lbl}}
    </li>
    <li>
      {{legalNoticesTxt.content4Lbl?legalNoticesTxt.content4Lbl:legalNotices.content4Lbl}}
    </li>
    <li>
      {{legalNoticesTxt.content5Lbl?legalNoticesTxt.content5Lbl:legalNotices.content5Lbl}}
    </li>
    <li>
      {{legalNoticesTxt.content6Lbl?legalNoticesTxt.content6Lbl:legalNotices.content6Lbl}}
    </li>
    <li>
      {{legalNoticesTxt.content7Lbl?legalNoticesTxt.content7Lbl:legalNotices.content7Lbl}}
    </li>
    <li>
      {{legalNoticesTxt.content8Lbl?legalNoticesTxt.content8Lbl:legalNotices.content8Lbl}} <a href="mailto:editor@Arconic.com">{{legalNoticesTxt.emailTextLbl?legalNoticesTxt.emailTextLbl:legalNotices.emailTextLbl}}</a>.
    </li>
    <li>
      {{legalNoticesTxt.content9Lbl?legalNoticesTxt.content9Lbl:legalNotices.content9Lbl}}
    </li>
  </ol>

  <p> <a href="../assets/Docs/arconic-european-legal-entities.pdf">{{legalNoticesTxt.content10Lbl?legalNoticesTxt.content10Lbl:legalNotices.content10Lbl}}</a> </p>
  <p> <a href="../assets/Docs/uk-slavery-and-human-trafficking-statement.pdf">{{legalNoticesTxt.content11Lbl?legalNoticesTxt.headingLbl:legalNotices.content11Lbl}}</a> </p>
  <p> <a href="../assets/Docs/California-Transparency-in-Supply-Chains-Act-Statement.pdf">{{legalNoticesTxt.content12Lbl?legalNoticesTxt.content12Lbl:legalNotices.content12Lbl}}</a> </p>

  <h4>{{legalNoticesTxt.content13Lbl?legalNoticesTxt.content13Lbl:legalNotices.content13Lbl}}</h4>

  <p>
    {{legalNoticesTxt.content14Lbl?legalNoticesTxt.content14Lbl:legalNotices.content14Lbl}}
  </p>

</div>
